/**
 * Labstep
 *
 * @module components/FilterPost/Report/Metadata
 * @desc Metadata filter
 */

import { FilterMetadataForm } from 'labstep-web/components/FilterPost/Report/Metadata/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Metadata } from 'labstep-web/models/metadata';
import type React from 'react';
import type { FilterPostReportMetadataProps } from './types';

const metadataNameCapitalised = Metadata.getHumanReadableEntityName(
  false,
  true,
);

export const FilterPostReportMetadata: React.FC<
  FilterPostReportMetadataProps
> = ({
  path,
  addPostFilter,
  defaultValues,
  replace,
  protocolValueName,
  ...rest
}) => (
  <Modal
    header={`Filter by ${metadataNameCapitalised}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
        dataCy="components/FilterPost/Report/Metadata/Active/Post"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterMetadataForm
        addPostFilter={addPostFilter}
        path={path}
        onDone={toggleModal}
        defaultValues={defaultValues}
        replace={replace}
        protocolValueName={protocolValueName}
      />
    )}
    {...rest}
  />
);
